import React, { useEffect, useRef, useState } from "react";
import Flip from "../Icons/Flip";

export const STATIC_DATA_COMICS: any = {
	"Sorted Sauce": {
		color_code: "#381116",
	},
	"Okay Olive": {
		color_code: "#92AA58",
	},
	"Cautious Cabbage": {
		color_code: "#8FB748",
	},
	"Discerning Donut": {
		color_code: "#D87B8A",
	},
	"Anxious Artichoke": {
		color_code: "#8AA23C",
	},
};

export const useContainerDimensions = (myRef: any) => {
	const getDimensions = () => ({
		width: myRef.current.offsetWidth,
		height: myRef.current.offsetHeight,
	});

	const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

	useEffect(() => {
		const handleResize = () => {
			setDimensions(getDimensions());
		};

		if (myRef.current) {
			setDimensions(getDimensions());
		}

		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, [myRef]);

	return dimensions;
};

const CohortsFlipCard = ({
	localKey,
	cohortData,
	isActiveCard,
	moveSlide,
}: {
	localKey: number;
	cohortData: any;
	isActiveCard: boolean;
	moveSlide: any;
}) => {
	const componentRef = useRef(null);
	const { width, height } = useContainerDimensions(componentRef);
	const [flipOnlyOnce, setFlipOnlyOnce] = useState(false);
	const myRefImage = useRef(null);
	const getCardUrl = (comicUrl: string) => {
		return comicUrl.replace("comic", "card");
	};

	const dummyFlip = () => {
		setClassIndex(0);
		setTimeout(() => {
			setClassIndex(2);
		}, 700);
	};

	useEffect(() => {
		if (isActiveCard == false) {
			setClassIndex(2);
		} else {
			if (flipOnlyOnce == false) {
				if (localKey == 0) {
					dummyFlip();
					setFlipOnlyOnce(true);
				}
			}
		}
	}, [isActiveCard]);

	const [classIndex, setClassIndex] = useState(2);
	const [prevState, setPrevState] = useState(2);

	const onClickFront = () => {
		//@ts-ignore
		if (isActiveCard) {
			if (prevState == 0) {
				//last
				setClassIndex(2);
			} else {
				//first
				setClassIndex(1);
			}
		} else {
			//move card to center
			moveSlide(localKey);
		}
	};

	const onClickRight = () => {
		//@ts-ignore
		if (isActiveCard) {
			setPrevState(0);
			setClassIndex(0);
		} else {
			//move card to center
			moveSlide(localKey);
		}
	};

	const onClickLeft = () => {
		//@ts-ignore
		if (isActiveCard) {
			setPrevState(2);
			setClassIndex(0);
		} else {
			//move card to center
			moveSlide(localKey);
		}
	};

	const getClassIndex = () => {
		if (classIndex == 0) {
			return "cube show-front";
		} else if (classIndex == 1) {
			return "cube show-right";
		} else {
			return "cube show-left";
		}
	};

	const toggleFront = () => {
		if (classIndex == 0) {
			return "show-card ";
		} else {
			return "hide-card";
		}
	};

	const toggleLeft = () => {
		if (classIndex == 2) {
			return "show-card ";
		} else {
			return "hide-card ";
		}
	};

	const toggleRight = () => {
		if (classIndex == 1) {
			return "show-card ";
		} else {
			return "hide-card ";
		}
	};

	const getWidthValue = () => {
		if (width > 500) {
			return 500;
		} else {
			return width;
		}
	};

	return (
		<>
			<div className="scene" ref={componentRef}>
				<div className={getClassIndex()}>
					<div
						className={"cube__face cube__face--front " + toggleFront()}
						onClick={onClickFront}
					>
						<img
							src={cohortData.comic}
							alt="Nature"
							ref={myRefImage}
							className="comic-image"
						/>
						{isActiveCard ? (
							<div className="flip-icon">
								<Flip />
							</div>
						) : (
							<></>
						)}
					</div>
					<div
						className={"cube__face cube__face--right " + toggleRight()}
						onClick={onClickRight}
					>
						<div className="cohorts-parent">
							<img
								src={cohortData.share_illustration}
								alt="Nature"
								className="cohorts-parent-cover"
							/>
							<div className="cohort-desc">
								<h1 className="heder-label">{cohortData.title}</h1>
								<div
									className="comic-desc-main"
									dangerouslySetInnerHTML={{ __html: cohortData.description }}
								></div>
							</div>
							{isActiveCard ? (
								<div className="flip-icon">
									<Flip />
								</div>
							) : (
								<></>
							)}
						</div>
					</div>
					<div
						className={"cube__face cube__face--left " + toggleLeft()}
						onClick={onClickLeft}
					>
						<img
							src={getCardUrl(cohortData.comic)}
							alt="Nature"
							className="comic-image"
						/>
						{isActiveCard ? (
							<div className="flip-icon">
								<Flip />
							</div>
						) : (
							<></>
						)}
					</div>
				</div>
			</div>

			<style jsx>{`
				.cohorts-parent {
					height: 100%;
				}
				.cohorts-parent-cover {
					position: absolute;
					opacity: 0.1;
					height: 50%;
					width: 50%;
					bottom: 5%;
					right: 5%;
					object-fit: scale-down;
				}
				.flip-icon {
					position: absolute;
					right: 5%;
					bottom: 2%;
				}
				.heder-label {
					margin: 10;
					font-size: 30px;
					font-family: Raleway;
					text-transform: uppercase;
					color: ${STATIC_DATA_COMICS[cohortData.title].color_code};
				}
				@media only screen and (min-width: 450px) {
					.heder-label {
						font-size: 34px;
					}
				}
				@media only screen and (min-width: 699px) {
					.heder-label {
						font-size: 38px;
						line-height: 40px;
					}
				}
				.cohort-desc {
					line-height: 23px;
					margin-bottom: 20px;
					font-size: 16px;
					text-align: left;
					font-family: Cabin, sans-serif;
				}
				@media only screen and (min-width: 450px) {
					.cohort-desc {
						line-height: 24px;
						font-size: 20px;
					}
				}
				@media only screen and (min-width: 699px) {
					.cohort-desc {
						line-height: 28px;
						font-size: 22px;
					}
				}
				.card-container {
					background-color: #fff3cd;
					color: black;
				}

				.comic-image {
					width: 100%;
					height: 100%;
					object-fit: scale-down;
					display: block;
				}

				.scene {
					width: 100%;
					height: 100%;
					perspective: ${getWidthValue() + getWidthValue()}px;
				}
				.cube {
					width: 100%;
					height: 100%;
					position: relative;
					transform-style: preserve-3d;
					transform: translateZ(${getWidthValue() / 2}px);
					transition: transform 1s;
				}
				.hide-card {
					opacity: 0;
					transition: opacity 0.4s;
					-webkit-transition: opacity 0.4s;
				}
				.show-card {
					transition: opacity 0.4s;
					-webkit-transition: opacity 0.4s;
					opacity: 1;
				}

				.cube.show-front {
					transform: translateZ(-250px) rotateY(0deg);
				}
				.cube.show-right {
					transform: translateZ(-250px) rotateY(-90deg);
				}
				.cube.show-left {
					transform: translateZ(-250px) rotateY(90deg);
				}

				.cube__face {
					position: absolute;
					width: 100%;
					height: 100%;
					padding: 4%;
				}

				.cube__face--front {
					background-color: #ffffff;
					box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
					border-radius: 35px;
					padding: 4%;
				}
				.cube__face--right {
					background-color: #ffffff;
					box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
					border-radius: 35px;
					padding: 7%;
					overflow: hidden;
				}
				.cube__face--left {
					background-color: #fff3cd;
					box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
					border-radius: 35px;
					padding: 4%;
				}

				.cube__face--front {
					transform: rotateY(0deg) translateZ(${getWidthValue() / 2}px);
				}
				.cube__face--right {
					transform: rotateY(90deg) translateZ(${getWidthValue() / 2}px);
				}
				.cube__face--left {
					transform: rotateY(-90deg) translateZ(${getWidthValue() / 2}px);
				}
				label {
					margin-right: 10px;
				}
				.comic-desc-main {
					overflow: scroll;
					height: 60vh;
					-ms-overflow-style: none;
					/* for Internet Explorer, Edge */
					scrollbar-width: none;
				}
				.comic-desc-main::-webkit-scrollbar {
					display: none;
					/* for Chrome, Safari, and Opera */
				}
			`}</style>
		</>
	);
};

export default CohortsFlipCard;
